import { FC } from "react";
import { Link } from "react-router-dom";

import __ from "web/Layout/Translations";

import ArrowLeftIcon from "web/assets/icons/arrow-left.svg";
import ArrowRightIcon from "web/assets/icons/arrow-right.svg";

import {
  trackCategoryCollapse,
  trackCategoryExpand,
} from "web/utils/system/GTM/navigationGtmEvents";

import { MenuItemType } from "web/types/Menu";

import CategoryListItem from "./CategoryListItem";
import classes from "./list.scss";
import type { Submenu } from "./utils/types";
import { CategoryListItemData } from "./utils/types";

interface ISubmenuViewProps {
  submenu: Submenu;
  onBack: () => void;
  onNavigate: () => void;
  onCategoryClick: (categoryId: number, hasSubcategory: boolean) => void;
}

const SubmenuView: FC<ISubmenuViewProps> = ({
  submenu,
  onBack,
  onNavigate,
  onCategoryClick,
}) => {
  return (
    <div className={classes.subcategoryRoot}>
      <div className={classes.subcategory}>
        <button
          className={classes.subcategoryHeader}
          type="button"
          onClick={() => {
            trackCategoryCollapse(submenu.title);
            onBack();
          }}
        >
          <ArrowLeftIcon width={10} />
          <span>{__(submenu.title)}</span>
        </button>
        {submenu.items?.map((submenuItem) => {
          if (submenuItem.type === MenuItemType.CATEGORY) {
            return (
              <CategoryListItem
                key={submenuItem.id || submenuItem.url}
                category={submenuItem as CategoryListItemData}
                parentLabel={submenu.title}
                onClick={() =>
                  onCategoryClick(
                    submenuItem.id_category as number,
                    submenuItem.hasSubcategory as boolean
                  )
                }
              />
            );
          }

          return (
            <Link
              key={submenuItem.id || submenuItem.url}
              className={classes.navItem}
              to={submenuItem.url}
              onClick={() => {
                trackCategoryExpand(submenuItem.title);
                onNavigate();
              }}
            >
              <span>{__(submenuItem.title)}</span>
              <ArrowRightIcon width={10} />
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default SubmenuView;
